import { render, staticRenderFns } from "./TemplatesIcon.vue?vue&type=template&id=98a155f2&"
import script from "./TemplatesIcon.vue?vue&type=script&lang=js&"
export * from "./TemplatesIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports